import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FlagContent } from './flag-content';
import { FlagLoading } from './flag-loading';
import { FlagError } from './flag-error';
export const UserFlagContent = ({ userFlagProps, loading, error, success, }) => {
    return (_jsxs(React.Fragment, { children: [loading && _jsx(FlagLoading, {}), !loading && error && _jsx(FlagError, {}), !loading && success && _jsx(FlagContent, { ...userFlagProps })] }));
};
//# sourceMappingURL=user-flag-content.js.map